export const GET_EXCHANGE_CONTRACT_PAYMENTS = 'GET_EXCHANGE_CONTRACT_PAYMENTS';
export const GET_EXCHANGE_CONTRACT_PAYMENTS_SUCCESS = 'GET_EXCHANGE_CONTRACT_PAYMENTS_SUCCESS';
export const GET_EXCHANGE_CONTRACT_PAYMENTS_ERROR = 'GET_EXCHANGE_CONTRACT_PAYMENTS_ERROR';

export const POST_EXCHANGE_CONTRACT_PAYMENT = 'POST_EXCHANGE_CONTRACT_PAYMENT';
export const POST_EXCHANGE_CONTRACT_PAYMENT_SUCCESS = 'POST_EXCHANGE_CONTRACT_PAYMENT_SUCCESS';
export const POST_EXCHANGE_CONTRACT_PAYMENT_ERROR = 'POST_EXCHANGE_CONTRACT_PAYMENT_ERROR';
